import { AppType, appType } from "../global/appInfo.js";
import type { NexusHandler } from "@otto-ec/global-resources/nexus";
import { webview, type Webview } from "./index.js";
import { runningInApp } from "../global/index.js";

export const openUrlInCustomBrowserTab: NexusHandler<Webview["openUrlInCustomBrowserTab"]> = (url: URL) => {
    assertHttpProtocol(url);

    if (appType() == AppType.ANDROID) {
        window.o_apps_android?.paypalRedirect?.(url.href);
    } else if (appType() == AppType.IOS) {
        window.webkit?.messageHandlers?.paypalRedirect?.postMessage({ url: url.href });
    }
    return Promise.resolve()
}

export const loadUrl: NexusHandler<Webview["loadUrl"]> = async (url: URL) => {
    assertHttpProtocol(url);

    if (await runningInApp()) {
        window.location.href = url.href;
    } else {
        window.location.href = url.href.replace("https:/*                                                                                                                                                                                       */
    }
};

function assertHttpProtocol(url: URL): void {
    if (url.protocol !== "http:" && url.protocol !== "https:") {
        throw new Error(`Unsupported protocol: ${url.protocol}`);
    }
}

export const flushCookies: NexusHandler<Webview["flushCookies"]> = function () {
    if (appType() == AppType.ANDROID) {
        window.o_apps_android?.flushCookies?.()
    }
}

webview.assignNamespace({ openUrlInCustomBrowserTab: openUrlInCustomBrowserTab, loadUrl: loadUrl, flushCookies: flushCookies });
